import { theme } from '~/theme';
import { cssColorHexToRgbA } from '~/utils/helpers/css';

export const useSxStyles = () => {
  return {
    avatar: { marginRight: '10px' },
    cellLabel: {
      fontWeight: 'bold',
    },
    dateCell: { width: '150px', gridArea: 'extra1' },
    daysCell: {
      width: '55px',
      gridArea: 'extra2',
    },
    smallCell: { width: '50px', gridArea: 'checkbox' },
    tableCellRoot: {
      padding: 0,
      borderBottom: 0,
    },
    textCell: {
      display: 'flex',
      gridArea: 'main',
      '& .textCellContent': {
        paddingRight: theme.spacing(2),
      },
    },
    tableRow: {
      '&:hover': {
        backgroundColor: cssColorHexToRgbA('#eaeaea', 0.5),
      },
    },
    selectedTableRow: {
      backgroundColor: '#e7f9ff',
      '&:hover': {
        backgroundColor: cssColorHexToRgbA('#e7f9ff', 0.5),
      },
    },
    semiItemRow: {
      padding: theme.spacing(1, 0),
      display: 'grid',
      gridTemplateAreas: `
        'checkbox main main'
        'checkbox extra1 extra2'
      `,
      gridRowGap: theme.spacing(),
      gridTemplateColumns: 'auto 2fr 1fr',
      '& .textCell .textCellContent': {
        paddingRight: 0,
      },
      '& .dateCell': {
        width: 'auto',
        paddingRight: theme.spacing(2),
      },
      '& .daysCell': {
        width: 'auto',
      },
    },
    itemRow: {
      padding: theme.spacing(1, 0),
      display: 'grid',
      gridTemplateAreas: `
        'checkbox main'
        'checkbox extra1'
        'checkbox extra2'
      `,
      gridRowGap: theme.spacing(),
      gridTemplateColumns: 'auto 1fr',
      '& .textCell .textCellContent': {
        paddingRight: 0,
      },
      '& .dateCell': {
        width: 'auto',
      },
      '& .daysCell': {
        width: 'auto',
      },
    },
  };
};
